import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DictionaryService } from '@app/core/services/dictionary.service';
import { TimetablePeriod } from '@app/pcs/models';

@Component({
  selector: 'pcs-user-settings-menu',
  templateUrl: './user-settings-menu.component.html',
  styleUrls: ['../base-menu-dropdown.scss', '../main-menu/main-menu.component.scss']
})
export class UserSettingsMenuComponent {
  @Input() currentUser;

  @Output() logout = new EventEmitter();

  ttp: TimetablePeriod;

  constructor(private readonly dictionaryService: DictionaryService) {
    this.ttp = this.dictionaryService.getDefaultTimetablePeriod();
  }

  get user() {
    return `${this.firstName} ${this.lastName}`;
  }

  get firstName() {
    return this.currentUser && this.currentUser.firstName;
  }

  get lastName() {
    return this.currentUser && this.currentUser.name;
  }

}
